<template>
	<div class="login">
		<div class="input-wrap">
			<div class="input-title">ログインID</div>
			<div class="sv-field">
				<input type="text" class="sv-input" v-model="loginId" placeholder="アカウントまたはメール" />
			</div>
		</div>

		<div class="input-wrap">
			<div class="input-title">パスワード</div>
			<div class="sv-field">
				<input type="password" class="sv-input" v-model="password"/>
			</div>
		</div>

		<div style="text-align: center">
			<sv-checkbox class="mt-30 mb-40" v-model="isLoginKeep">ログインしたままにする</sv-checkbox>
		</div>

		<div class="login-error mb-10" v-show="isLoginError">ログイン情報がちがいます</div>

		<b-button class="mb-15 max-w-button" rounded type="is-primary" @click="onLoginClick" :loading="isLoading">ログイン</b-button>

		<div class="sv-footer max-w-button">
			<a :href="$utils.getHostName() + '/privacy-policy.html'" target="_blank">プライバシーポリシー</a>
			<span>&copy; ️hohoemi, Co., Ltd.</span>
		</div>

	</div>
</template>

<script>
import SvCheckbox from '@/components/SvCheckbox'

export default {
	name: 'Login',
	components: {
		SvCheckbox,
	},
	data () {
		return {
			isLoading: false,
			isLoginError: false,
			loginId: '',
			password: '',
			isLoginKeep: false,
		}
	},
	created() {
		this.$store.commit('basic', {
			key: 'isNavBarShow',
			value: false,
		});
		this.$store.commit('basic', {
			key: 'isFloatingMenuShow',
			value: false,
		});
	},
	mounted() {
		this.isLoginKeep = this.$store.state.isLoginKeep;
	},
	methods: {
		onLoginClick: async function() {
			this.isLoginError = false;
			this.isLoading = true;

			this.$auth.login(this.loginId, this.password)
				.then(() => {
					this.$store.commit('basic', {
						key: 'isLoginKeep',
						value: this.isLoginKeep,
					})
					this.$router.push({ name: 'top' })
				})
				.catch((error) => {
					if (parseInt(error.message) === 401) {
						this.isLoginError = true;
					} else {
						this.$utils.toastError('サーバとの通信に失敗しました');
					}
				})
				.finally(() => {
					this.isLoading = false;
				}
			);
		}
	}
}
</script>

<style lang="scss" scoped>
@import '@/scss/_vars.scss';

.login-error {
	color: $red;
	text-align: center;
}

.sv-footer {
	margin-top: 50px;
	font-size: 14px;
	a {
		display: block;
		color: $color;
		margin-bottom: 8px;
	}
}

</style>
